import { render, staticRenderFns } from "./Game_EventNoti.vue?vue&type=template&id=047fa026&scoped=true&"
import script from "./Game_EventNoti.vue?vue&type=script&lang=js&"
export * from "./Game_EventNoti.vue?vue&type=script&lang=js&"
import style0 from "./Game_EventNoti.vue?vue&type=style&index=0&id=047fa026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fa026",
  null
  
)

export default component.exports